/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteStagedGachaRequest } from '../../models/delete-staged-gacha-request';
import { DeleteStagedGachaResponse } from '../../models/delete-staged-gacha-response';

export interface AdminServiceDeleteStagedGacha$Params {
      body: DeleteStagedGachaRequest
}

export function adminServiceDeleteStagedGacha(http: HttpClient, rootUrl: string, params: AdminServiceDeleteStagedGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteStagedGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceDeleteStagedGacha.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteStagedGachaResponse>;
    })
  );
}

adminServiceDeleteStagedGacha.PATH = '/api/v3/gateway/admin/stage/gacha/delete';
